import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'primary' | 'outline';
  className?: string;
};
export function CtaButton({
  children,
  href = '#planes',
  size = 'lg',
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex items-center justify-center rounded-full font-display font-bold tracking-wide transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-violeta-300';
  const sizes = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base sm:text-lg'
  };
  const variants = {
    primary: 'bg-violeta-500 text-white hover:bg-violeta-400 shadow-lg shadow-violeta-700/30',
    outline: 'border border-violeta-400/60 text-violeta-100 hover:border-violeta-300 hover:text-white'
  };
  return <a href={href} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-194" data-mp="1866desimf4hg">
      {children}
    </a>;
}